function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BOS, HALIFAX, LLOYDS, LLOYDS2023, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.248 23.752A.827.827 0 0 0 .847 24a.827.827 0 0 0 .599-.248L12 13.198l10.554 10.554a.827.827 0 0 0 .6.248.848.848 0 0 0 .599-1.446L13.197 12 23.752 1.446A.848.848 0 0 0 22.554.248L12 10.802 1.446.248A.848.848 0 0 0 .248 1.446L10.802 12 .248 22.554a.848.848 0 0 0 0 1.198z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0.585786438 L23.4142136,2 L13.4137864,11.9997864 L23.4142136,22 L22,23.4142136 L11.9997864,13.4137864 L2,23.4142136 L0.585786438,22 L10.5857864,11.9997864 L0.585786438,2 L2,0.585786438 L11.9997864,10.5857864 L22,0.585786438 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.248 23.752A.827.827 0 0 0 .847 24a.827.827 0 0 0 .599-.248L12 13.198l10.554 10.554a.827.827 0 0 0 .6.248.848.848 0 0 0 .599-1.446L13.197 12 23.752 1.446A.848.848 0 0 0 22.554.248L12 10.802 1.446.248A.848.848 0 0 0 .248 1.446L10.802 12 .248 22.554a.848.848 0 0 0 0 1.198z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.1992 12.0019L22.5091 3.67858C23.1217 3.06495 23.1217 2.07385 22.5091 1.46022C21.8965 0.846593 20.9068 0.846593 20.2942 1.46022L11.9843 9.78339L3.6744 1.46022C3.06176 0.846593 2.07212 0.846593 1.45948 1.46022C0.84684 2.07385 0.84684 3.06495 1.45948 3.67858L9.76937 12.0019L1.45948 20.3253C0.84684 20.9389 0.84684 21.93 1.45948 22.5437C1.77365 22.8583 2.16637 23 2.57479 23C2.98322 23 3.37594 22.8426 3.69011 22.5437L11.9838 14.2205L20.3099 22.5437C20.6241 22.8583 21.0168 23 21.4252 23C21.8336 23 22.2263 22.8426 22.5405 22.5437C23.1532 21.93 23.1532 20.9389 22.5405 20.3253L14.1992 12.0019Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5882L22.5883 24L12 13.4118L1.41177 24L4.24341e-05 22.5882L10.5882 12L-9.87363e-07 1.41177L1.41177 -6.17103e-08L12 10.5882L22.5883 -3.34123e-05L24 1.41173L13.4118 12L24 22.5882Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.0024541,9.54895799 L20.9855437,0.513589808 C21.6703258,-0.173464149 22.7809675,-0.173464149 23.4759702,0.52729662 C24.1675661,1.22291733 24.1607523,2.35544269 23.4878943,3.03221653 L14.5686925,12.0033251 L23.4878943,20.9744336 C24.1726764,21.6632009 24.1726764,22.7803061 23.4759702,23.4793535 C22.7843744,24.1749742 21.6584018,24.1681208 20.9855437,23.491347 L11.9975459,14.451042 L3.01445626,23.4864102 C2.32967415,24.1734641 1.21903252,24.1734641 0.524029788,23.4727034 C-0.167566072,22.7770827 -0.16075232,21.6445573 0.512105722,20.9677835 L9.43130751,11.9966749 L0.512105722,3.02556641 C-0.172676386,2.3367991 -0.172676386,1.21969391 0.524029788,0.520646496 C1.21562565,-0.174974219 2.34159822,-0.168120813 3.01445626,0.508653036 L12.0024541,9.54895799 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.247849 23.7522C0.413081 23.9174 0.619621 24 0.846816 24C1.07401 24 1.28055 23.9174 1.44578 23.7522L12 13.1979L22.5542 23.7522C22.7194 23.9174 22.926 24 23.1532 24C23.3597 24 23.5869 23.9174 23.7522 23.7522C24.0826 23.4217 24.0826 22.8847 23.7522 22.5542L13.1979 12L23.7522 1.44578C24.0826 1.11532 24.0826 0.578313 23.7522 0.247849C23.4217 -0.0826162 22.8847 -0.0826162 22.5542 0.247849L12 10.8021L1.44578 0.247849C1.11532 -0.0826162 0.578313 -0.0826162 0.247849 0.247849C-0.0826162 0.578313 -0.0826162 1.11532 0.247849 1.44578L10.8021 12L0.247849 22.5542C-0.0826162 22.8847 -0.0826162 23.4217 0.247849 23.7522Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import React from 'react';
import { ThemeContext } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = React.useContext(ThemeContext) || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.close) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.close;
  } else {
    switch (brand) {
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}